/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_TimeoutInputs */



/**
* | output |
* | --- |
* | "The request to the AI provider timed out. Please try again." |
*
* @param {Chat_Error_TimeoutInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_timeout = /** @type {((inputs?: Chat_Error_TimeoutInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_TimeoutInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Anfrage an den KI-Anbieter hat zu lange gedauert. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("The request to the AI provider timed out. Please try again.")
});